import React from 'react'

function EditorDashboard() {
  return (
     <div className='Admin_Dashboard' >
      <h1>Editor Dashboard</h1>
    </div>
  )
}

export default EditorDashboard
